export default "__VITE_ASSET__BfS_7EYR__"